import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout/Layout';
import QuestionCard from './components/QuestionCard/QuestionCard';
import useReviewTraining from './logic/useReviewTraining';
import reviewTrainingService from './logic/useReviewTrainingService';
import { Alert, Spin, message } from "antd";
import './ReviewTraining.scss';

function ReviewTraining() {
    const { 
        trainingId,
        userId,
        data, 
        isFetching, 
        error,
        trainingHeader,
        trainingError,
        isFetchingTraining,
        authenticatedUser,
        evaluationScores,
        evaluationScoresError,
        evaluationScoresIsFetching,
    } = useReviewTraining();
    const [scores, setScores] = useState({});
    const [trainingEvaluationId, setTrainingEvaluationId] = useState(null);
    const fetchTrainingEvaluationId = async (trainingId, userId, setTrainingEvaluationId) => {
        try {
            const response = await reviewTrainingService.findByEvalLink(trainingId, userId);
            setTrainingEvaluationId(response.id);
        } catch (error) {
            console.error('Error fetching trainingEvaluationId:', error);
        }
    };
    useEffect(() => {
        if (trainingId && userId) {
            fetchTrainingEvaluationId(trainingId, userId, setTrainingEvaluationId);
        }
    },  [trainingId, userId]);


    const handleScoreChange = (questionId, score, remove) => {
        if (remove) {
            setScores((previousScores) => {
                delete previousScores[questionId];
                return previousScores;
            });
        } else setScores({ ...scores, [questionId]: score });
    };

    const handleSubmit = async () => {
        try {
            const scoresToSubmit = data.map(questionData => ({
                questionId: questionData.id,
                score: scores[questionData.id] || 0,
                trainingEvaluationId: trainingEvaluationId,
            }));

            if (scoresToSubmit.some((scoreToSubmit) => scoreToSubmit.score === 0)) {
                message.warning('Please make sure you answered all the questions')
            } else {
                await reviewTrainingService.submitReviewScores(scoresToSubmit);
                message.success('Evaluation submitted successfully')
            }
        } catch (error) {
            console.error('Error submitting review:', error);
        }
    };

    return (
        <div className="review-training-container">
            <Layout pageName="Evaluation">
                <div className="review-training">
                    <div className="review-training-title">
                        <label>Training evaluation</label>
                        <label>React Course</label>
                    </div>
                    {
                        evaluationScoresIsFetching ? <Spin />
                            : evaluationScoresError ? <Alert message="An error has occurred" type="error" showIcon />
                                : !evaluationScoresIsFetching && !evaluationScoresError && new Date() < new Date(evaluationScores.dueDate) && evaluationScores.scores.length === 0
                                    ?
                                    <>
                                        {
                                            isFetchingTraining ? <Spin />
                                                : trainingError ? <Alert message="An error has occurred" type="error" showIcon />
                                                    : authenticatedUser
                                                    && authenticatedUser.id === userId
                                                    && (!isFetchingTraining && !trainingError)
                                                    &&
                                                    <div className="review-training-header">
                                                        <div className="review-training-part">
                                                            <div>
                                                                <label>Participant: </label>
                                                                <label className="participant">{authenticatedUser.firstName} {authenticatedUser.lastName}</label>
                                                            </div>
                                                            {/* <label>Trainer: Andria Scavo</label> */}
                                                        </div>
                                                        {/* <div className="review-training-part">
                                                        <label>Course_Ref</label>
                                                        <label>#54516546546</label>
                                                    </div> */}
                                                        <div className="review-training-part">
                                                            <label>from : {(new Date(trainingHeader.data.start_date)).toDateString()}</label>
                                                            <label>to : {(new Date(trainingHeader.data.end_date)).toDateString()}</label>
                                                        </div>
                                                    </div>
                                        }
                                        <div className="review-training-questions">
                                            {isFetching ? <Spin />
                                                : !authenticatedUser || authenticatedUser.id !== userId ?
                                                    <Alert message="This link does not belongs to you" type="warning" showIcon />
                                                    : error ? <Alert message="An error has occurred" type="error" showIcon />
                                                        :
                                                        data && data.length
                                                            ?
                                                            data?.map((questionData) => (
                                                                <QuestionCard key={questionData?.id} onSelectScore={(score, remove) => handleScoreChange(questionData?.id, score, remove)}>
                                                                    {questionData?.question}
                                                                </QuestionCard>
                                                            ))
                                                            : <Alert message="No questions available for now" type="info" showIcon />
                                            }
                                        </div>
                                        <div className="review-training-btn">
                                            <button className="review-btn" onClick={handleSubmit}>
                                                Submit
                                            </button>
                                        </div>
                                    </> : new Date() > new Date(evaluationScores.dueDate)
                                        ? <Alert message="This link has expired." type="info" showIcon />
                                        : <Alert message="You have submitted your evaluation for this training." type="info" showIcon />
                    }
                </div>
            </Layout>
        </div>
    );
}

export default ReviewTraining;
